// sagas.ts
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchNewsFailure, FetchNewsRequestAction, fetchNewsSuccess } from './actions';
import { FETCH_NEWS_REQUEST } from './constants';
import api from '../../../../api-new/http';
import { appUrls } from '../../../../api-new/urls';
import { sendError } from '../../errorHandler';
import { getErrorSetup } from '../../../../helpers/getErrorSetup';

export function* newsSaga(action: FetchNewsRequestAction) {
    const symbol = action.payload.symbol;

    try {
        if(!symbol) return;
        const data = yield call(() => api.get(`${appUrls.stockURL}/company/${symbol}/news`));

        if (data) {
            yield put(fetchNewsSuccess(data.data));
        }
    } catch (error) {
        yield put(fetchNewsFailure(error as any));
        yield put(
            sendError({
                error: getErrorSetup(error),
                processingType: 'alert',
            }),
        );
    }
}

export function* rootStockNewsSaga(): Generator {
    yield takeLatest(FETCH_NEWS_REQUEST, newsSaga);
}
